var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 14.95H12.35L13.65 9.75H9.1V7.15C9.1 5.811 9.1 4.55 11.7 4.55H13.65V0.182C13.2262 0.1261 11.6259 0 9.9359 0C6.4064 0 3.9 2.1541 3.9 6.11V9.75H0V14.95H3.9V26H9.1V14.95Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebookicon.ec0168b7aa71c7e4b5863a22232ecda6.svg";
export { ForwardRef as ReactComponent };